export default "__VITE_ASSET__BHTNo2M___"